// Sidenav.js
import React from 'react';
import SidenavTitle from './SidenavTitle';

const Sidenav = () => {
  // Группируем данные для лучшей читаемости и возможного переиспользования
  const menuSections = [
    {
      id: 'menu',
      title: 'M',
      subTitle: 'enu',
      items: ['Blog Page', 'Portfolio Page']
    },
    {
      id: 'projects',
      title: 'P',
      subTitle: 'rojects',
      items: [
        'Web Development',
        'E-commerce',
        'Chatting Applications',
        'Portfolio Websites',
        'Backend Setup',
        'Amazon Clone'
      ]
    },
    {
      id: 'posts',
      title: 'L',
      subTitle: 'atest Posts',
      items: [
        'UI & UX Conference at Lviv 2022',
        'How to become a creative designer',
        'Designers thoughts about mobile UI templates',
        'Designer Conference at Florida, USA 2020'
      ]
    }
  ];

  return (
    <div className="px-7 py-6 space-y-8"> {/* Увеличил отступы и добавил space-y */}
      {menuSections.map((section) => (
        <div key={section.id} className="space-y-4"> {/* Группируем элементы секции */}
          <SidenavTitle title={section.title} subTitle={section.subTitle} />
          <ul className="space-y-3"> {/* Вертикальные отступы между пунктами */}
            {section.items.map((item, index) => (
              <li
                key={`${section.id}-${index}`}
                className="sidenavLi transition-colors duration-200 hover:text-designColor"
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default Sidenav;